import "core-js/modules/es6.function.name.js";
import _toConsumableArray from "/Users/manel/devel/ajfigueres/ajfigueres-geoportal/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes as baseRoutes } from '@giscube/geoportal-ee';
import customRoutes from "./routes";
var routes = [].concat(_toConsumableArray(customRoutes), _toConsumableArray(baseRoutes)); // https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378

var originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  var _this = this;

  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  return originalPush.call(this, location).catch(function (err) {
    if (err.name === 'NavigationDuplicated') {
      return _this.currentRoute;
    }

    throw err; // Vue Router 3.4.0+
    // if (VueRouter.isNavigationFailure && VueRouter.isNavigationFailure(err)) {
    //   // resolve err
    //   return err
    // }
    // // rethrow error
    // return Promise.reject(err)
  });
};

Vue.use(VueRouter);
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function (_ref) {
  var Vue = _ref.Vue,
      store = _ref.store;
  var Router = new VueRouter({
    scrollBehavior: function scrollBehavior() {
      return {
        x: 0,
        y: 0
      };
    },
    routes: routes,
    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  });
  Router.beforeEach(function (to, from, next) {
    store.dispatch('layout/applyDialogs', {
      to: to,
      from: from,
      next: next
    });
  });
  return Router;
}